import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-between h-full" }
const _hoisted_2 = { class: "px-6 md:px-8 pt-6 pb-20 max-w-6xl" }
const _hoisted_3 = { "aria-label": "Progress" }
const _hoisted_4 = {
  role: "list",
  class: "overflow-hidden"
}
const _hoisted_5 = {
  key: 0,
  class: "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-blue-600",
  "aria-hidden": "true"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex h-9 items-center" }
const _hoisted_8 = { class: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full bg-blue-600 group-hover:bg-blue-800" }
const _hoisted_9 = { class: "ml-4 flex min-w-0 flex-col" }
const _hoisted_10 = { class: "flex items-center gap-1" }
const _hoisted_11 = { class: "text-sm font-medium" }
const _hoisted_12 = { class: "text-sm text-gray-500" }
const _hoisted_13 = {
  key: 0,
  class: "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300",
  "aria-hidden": "true"
}
const _hoisted_14 = {
  class: "group relative flex items-start",
  "aria-current": "step"
}
const _hoisted_15 = { class: "ml-4 flex min-w-0 flex-col" }
const _hoisted_16 = { class: "h-9 flex items-center gap-1" }
const _hoisted_17 = { class: "text-sm font-medium text-blue-600 shrink-0" }
const _hoisted_18 = {
  key: 1,
  class: "flex w-full justify-end"
}
const _hoisted_19 = {
  key: 2,
  class: "flex w-full justify-end"
}
const _hoisted_20 = { class: "sm:min-w-[30rem]" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = ["checked"]
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "mb-4 flex flex-col gap-4" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "sm:flex sm:justify-between w-full" }
const _hoisted_33 = { class: "flex flex-col text-sm" }
const _hoisted_34 = { class: "font-medium text-gray-900" }
const _hoisted_35 = { class: "mt-2 flex text-sm sm:ml-4 sm:mt-0" }
const _hoisted_36 = { class: "font-medium text-gray-900" }
const _hoisted_37 = { class: "ml-1 text-gray-500" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "mb-4 flex flex-col gap-4" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "sm:flex sm:justify-between w-full" }
const _hoisted_42 = { class: "flex flex-col text-sm" }
const _hoisted_43 = { class: "font-medium text-gray-900" }
const _hoisted_44 = { class: "mt-2 flex text-sm sm:ml-4 sm:mt-0" }
const _hoisted_45 = { class: "font-medium text-gray-900" }
const _hoisted_46 = { class: "ml-1 text-gray-500" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 3 }
const _hoisted_49 = { class: "flex flex-wrap gap-2 mb-4" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "text-xs" }
const _hoisted_52 = { class: "text-lg font-semibold" }
const _hoisted_53 = { class: "text-xs" }
const _hoisted_54 = { class: "flex flex-wrap gap-2 mb-6" }
const _hoisted_55 = { class: "w-24 h-20 leading-6 border-2 border-black rounded-lg flex flex-col items-center justify-center relative" }
const _hoisted_56 = { class: "text-xs" }
const _hoisted_57 = { class: "text-lg font-semibold" }
const _hoisted_58 = { class: "text-xs" }
const _hoisted_59 = {
  key: 0,
  class: "w-24 h-20 border-2 border-dashed border-gray-400 rounded-lg"
}
const _hoisted_60 = { key: 4 }
const _hoisted_61 = {
  key: 1,
  class: "mt-4 text-sm text-gray-500"
}
const _hoisted_62 = { key: 6 }
const _hoisted_63 = { class: "flex items-center" }
const _hoisted_64 = ["checked"]
const _hoisted_65 = { class: "flex items-center" }
const _hoisted_66 = ["checked"]
const _hoisted_67 = { key: 7 }
const _hoisted_68 = { class: "mt-4 w-64" }
const _hoisted_69 = { key: 8 }
const _hoisted_70 = { class: "flex flex-col gap-4 mt-2" }
const _hoisted_71 = { key: 9 }
const _hoisted_72 = { key: 10 }
const _hoisted_73 = { key: 11 }
const _hoisted_74 = { key: 12 }
const _hoisted_75 = { class: "space-y-4" }
const _hoisted_76 = { class: "flex justify-between items-center mb-3" }
const _hoisted_77 = { class: "font-medium text-gray-900" }
const _hoisted_78 = { class: "space-y-4" }
const _hoisted_79 = { key: 13 }
const _hoisted_80 = { class: "space-y-4" }
const _hoisted_81 = { class: "flex justify-between items-center mb-3" }
const _hoisted_82 = { class: "font-medium text-gray-900" }
const _hoisted_83 = { class: "space-y-4" }
const _hoisted_84 = {
  key: 0,
  class: "text-sm text-yellow-800 bg-yellow-50 border border-yellow-200 rounded-md p-3"
}
const _hoisted_85 = { key: 14 }
const _hoisted_86 = { class: "divide-y divide-gray-100" }
const _hoisted_87 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_88 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_89 = {
  key: 0,
  class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0"
}
const _hoisted_90 = {
  key: 0,
  class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0"
}
const _hoisted_91 = {
  key: 0,
  class: "text-gray-500 whitespace-nowrap"
}
const _hoisted_92 = {
  key: 0,
  class: "mt-2 font-medium text-gray-900"
}
const _hoisted_93 = {
  key: 1,
  class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0"
}
const _hoisted_94 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_95 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_96 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_97 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_98 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_99 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_100 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_101 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_102 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_103 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_104 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_105 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_106 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_107 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_108 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_109 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_110 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_111 = { class: "text-sm font-medium leading-6 text-gray-900" }
const _hoisted_112 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_113 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_114 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_115 = { class: "px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0" }
const _hoisted_116 = { class: "mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0" }
const _hoisted_117 = { class: "flex gap-2 my-6" }
const _hoisted_118 = {
  key: 0,
  class: "absolute left-4 top-4 -ml-px mt-0.5 h-full w-0.5 bg-gray-300",
  "aria-hidden": "true"
}
const _hoisted_119 = ["onClick"]
const _hoisted_120 = {
  class: "flex h-9 items-center",
  "aria-hidden": "true"
}
const _hoisted_121 = { class: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-gray-300 bg-white group-hover:border-gray-400" }
const _hoisted_122 = { class: "ml-4 flex min-w-0 flex-col" }
const _hoisted_123 = { class: "flex items-center gap-1" }
const _hoisted_124 = { class: "text-sm font-medium" }
const _hoisted_125 = {
  key: 0,
  class: "text-sm text-gray-500"
}

import { MenuItem } from '@headlessui/vue'
import { CheckCircleIcon, CheckIcon } from '@heroicons/vue/20/solid'
import { XCircleIcon } from '@heroicons/vue/20/solid'
import {
  CalendarIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  ClockIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  DocumentCheckIcon,
  RectangleGroupIcon,
  ShoppingBagIcon
} from '@heroicons/vue/24/outline'
import { DatePicker } from 'v-calendar'
import { computed, reactive, ref, watch } from 'vue'
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { useToast } from '@/composables/useToast'
import { AUTOMATION_LISTS } from '@/config/nav/automation'
import { audienceConfirmRows } from '@/helpers/autocharge'
import {
  membershipTierOptions,
  workflowActionConfigFromServer,
  workflowActionIsComplete,
  workflowActionOptions
} from '@/helpers/automationLists'
import { dateObjectToServerDay, serverDayToDateObject } from '@/helpers/dates'
import { listRecipientRows, recipientCountsEndpoint, recipientSummary } from '@/helpers/messageRecipients'
import privilegeService from '@/services/privilege.service'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'


export default {
  __name: 'AutomationNeue',
  setup(__props) {

const vuexStore = useStore()
const route = useRoute()
const router = useRouter()
const { showToast } = useToast()

const canCreateAutomations = computed(() => privilegeService.canAccessResourceAction('automation', null, 'create'))
const canUpdateAutomations = computed(() => privilegeService.canAccessResourceAction('automation', null, 'update'))
const canDeleteAutomations = computed(() => privilegeService.canAccessResourceAction('automation', null, 'delete'))

const loading = ref(true)
const hasUnsavedChanges = ref(false)
const existing = computed(() => route.params.id !== 'new')
const currentStep = ref(existing.value ? 1 : 0)

const steps = computed(() =>
  [
    {
      id: 'type',
      name: 'Type'
    },
    type.value !== 'workflow' && {
      id: 'lists',
      name: 'Lists'
    },
    type.value === 'message' && {
      id: 'message',
      name: 'Message'
    },
    type.value === 'drop' && {
      id: 'store',
      name: 'Store'
    },
    type.value === 'drop' && {
      id: 'fulfillment',
      name: 'Fulfillment'
    },
    ...(type.value === 'drop'
      ? reminders.value.map((x, i) => ({
          id: 'message-reminders',
          name: 'Reminder ' + (i + 1),
          reminder: x
        }))
      : []),
    type.value === 'drop' && {
      id: 'autofill',
      name: 'Autofill'
    },
    type.value === 'drop' &&
      autofill.enabled && {
        id: 'autocharge',
        name: 'Autocharge'
      },
    type.value === 'workflow' && {
      id: 'workflow-name',
      name: 'Workflow'
    },
    type.value === 'workflow' && {
      id: 'trigger',
      name: 'Trigger'
    },
    type.value === 'workflow' && {
      id: 'conditions',
      name: 'Conditions'
    },
    type.value === 'workflow' && {
      id: 'actions',
      name: 'Actions'
    },
    type.value === 'message' && {
      id: 'time',
      name: 'Time'
    },
    {
      id: 'preview',
      name: 'Preview'
    }
  ].filter(Boolean)
)

const drop = computed(() =>
  type.value === 'drop' ? mapRelationship({ type: 'bottle_cycle', id: route.params.id }) : undefined
)
const automation = computed(() =>
  type.value === 'message' ? mapRelationship({ type: 'message_automation', id: route.params.id }) : undefined
)
const scheduler = computed(() => mapRelationship(automation.value?.relationships.automation_scheduler.data))
const template = computed(() => mapRelationship(automation.value?.relationships.message_template.data))
const existingImages = computed(() => mapRelationships(template.value?.relationships.attachments.data))
const detail = audience => mapRelationship(audience?.relationships.audience_detail.data)

const stores = computed(() => mapType('store'))
const tiersAudiences = computed(() =>
  mapType('membership_tier')
    ?.map(x => mapRelationship(x.relationships.audience.data))
    .filter(Boolean)
)
const tierOptions = computed(() => membershipTierOptions(mapType('membership_tier')))
const tierOption = id => tierOptions.value.find(option => option.value === id)
const audienceResults = ref(null)
const audienceQuery = ref('')

const type = ref(route.meta.automation)
const selectedAudiences = ref([])
const segment = ref('all')
const store = ref(null)
const days = ref([])
const reminders = ref([{ message: null, images: null, date: null, completed: false }])
const message = ref(null)
const messageValidationPassed = ref(null)
const images = ref(null)
const attachmentType = ref('image')
const now = ref(true)
const date = ref(null)
const repeat = ref('once')
const autofill = reactive({})
const autocharge = reactive({})
const name = ref('')
const workflowName = ref('')
const triggerType = ref('ReceivedSmsWorkflowTrigger')
const conditions = ref([{ type: 'TextWorkflowCondition', operator: 'is_exactly', value: '' }])
const actions = ref([{ type: 'SendSmsWorkflowAction', config: { message: '' }, order: 1 }])

const slots = computed(() =>
  mapType('fulfillment_slot').filter(x => {
    if (!x.relationships?.fulfillment_method?.data) return
    const storeObj = mapRelationship({ type: 'store', id: store.value })
    const pairs = mapRelationships(storeObj?.relationships.fulfillment_method_store_pairs.data)
    return pairs.some(y => y.attributes.fulfillment_method_id.toString() === x.relationships.fulfillment_method.data.id)
  })
)
const upcomingDays = computed(() =>
  [
    ...new Set(
      slots.value
        .map(x => x.attributes.fulfillment_date)
        .filter(x => serverDayToDateObject(x) > new Date())
        .sort()
    )
  ].slice(0, 8)
)
const slotsForDay = day => slots.value.filter(x => x.attributes.fulfillment_date === dateObjectToServerDay(day))
const getSlots = days => {
  for (const day of days) {
    for (const slot of slotsForDay(day)) {
      vuexStore.commit('DESTROY_OBJECT', { data: slot })
    }
  }
  const from = dateObjectToServerDay(days.at(0))
  const to = dateObjectToServerDay(days.at(-1))
  return api.call(
    'GET',
    `fulfillment_slots?date_from=${from}&date_to=${to}&included=duplicator,fulfillment_method,fulfillment_availabilities`
  )
}

const toggleAudience = audience => {
  if (!canUpdateAutomations.value) return
  const found = selectedAudiences.value.find(x => x.id === audience.id)
  if (found) {
    selectedAudiences.value = selectedAudiences.value.filter(x => x.id !== audience.id)
  } else {
    selectedAudiences.value.push(audience)
  }
  hasUnsavedChanges.value = true
}

const changeImages = imgs => {
  if (!canUpdateAutomations.value) return
  images.value = imgs
  hasUnsavedChanges.value = true
}

const addReminder = () => {
  if (!canUpdateAutomations.value) return
  reminders.value.push({ message: '', image: null, date: new Date(), completed: false })
}

const deleteReminder = reminder => {
  if (!canUpdateAutomations.value) return
  if (reminders.value.indexOf(reminder) === reminders.value.length - 1) currentStep.value--
  reminders.value = reminders.value.filter(x => x !== reminder)
}

const addCondition = () => {
  if (!canUpdateAutomations.value) return
  conditions.value.push({ type: 'TextWorkflowCondition', operator: 'is_exactly', value: '' })
  hasUnsavedChanges.value = true
}

const conditionOperatorOptions = type =>
  type === 'TimeWorkflowCondition'
    ? [
        { name: 'Is Between', value: 'is_between' },
        { name: 'Is Not Between', value: 'is_not_between' }
      ]
    : [
        { name: 'Contains', value: 'contains' },
        { name: 'Is Exactly', value: 'is_exactly' },
        { name: 'Starts With', value: 'starts_with' },
        { name: 'Ends With', value: 'ends_with' }
      ]

const onConditionTypeChange = (condition, type) => {
  condition.type = type
  if (type === 'TimeWorkflowCondition') {
    condition.operator = 'is_between'
    condition.value = 'working_hours'
  } else {
    condition.operator = 'is_exactly'
    condition.value = ''
  }
  hasUnsavedChanges.value = true
}

const deleteCondition = index => {
  if (!canUpdateAutomations.value) return
  if (conditions.value.length > 1) {
    conditions.value.splice(index, 1)
    hasUnsavedChanges.value = true
  }
}

const addAction = () => {
  if (!canUpdateAutomations.value) return
  actions.value.push({ type: 'SendSmsWorkflowAction', config: { message: '' }, order: actions.value.length + 1 })
  hasUnsavedChanges.value = true
}

const deleteAction = index => {
  if (!canUpdateAutomations.value) return
  if (actions.value.length > 1) {
    actions.value.splice(index, 1)
    actions.value.forEach((action, idx) => {
      action.order = idx + 1
    })
    hasUnsavedChanges.value = true
  }
}

const selectedDay = ref(null)
const toggleDay = day => {
  if (!canUpdateAutomations.value) return
  hasUnsavedChanges.value = true
  if (days.value.includes(day)) {
    days.value = days.value.filter(x => x !== day)
  } else {
    days.value.push(day)
    selectedDay.value = serverDayToDateObject(day)
  }
}

const stepValid = computed(() => {
  if (steps.value[currentStep.value].id === 'lists') return selectedAudiences.value.length
  if (steps.value[currentStep.value].id === 'store') return store.value
  if (steps.value[currentStep.value].id === 'message')
    return (message.value || images.value) && messageValidationPassed.value
  if (steps.value[currentStep.value].id === 'time') return date.value || now.value
  if (steps.value[currentStep.value].id === 'autofill') return !autofill.enabled || autofill.type
  if (steps.value[currentStep.value].id === 'autocharge') return !autocharge.enabled || autocharge.date
  if (steps.value[currentStep.value].id === 'message-reminders')
    return (
      steps.value[currentStep.value].reminder.message &&
      steps.value[currentStep.value].reminder.date &&
      steps.value[currentStep.value].reminder.messageValidationPassed !== false
    )
  if (steps.value[currentStep.value].id === 'workflow-name') return workflowName.value.trim()
  if (steps.value[currentStep.value].id === 'trigger') return triggerType.value
  if (steps.value[currentStep.value].id === 'conditions')
    return conditions.value.every(condition => condition.value.trim())
  if (steps.value[currentStep.value].id === 'actions') return actions.value.every(workflowActionIsComplete)

  return true
})

const stepPreview = step =>
  ({
    type: type.value === 'drop' ? 'Drop' : type.value === 'workflow' ? 'Workflow' : 'Message',
    lists: type.value !== 'workflow' ? selectedAudiences.value.map(x => x.attributes.audience_name).join(', ') : 'N/A',
    store: mapRelationship({ type: 'store', id: store.value })?.attributes.store_name,
    fulfillment: days.value.length + ' days selected',
    message: message.value,
    time: now.value
      ? 'Send now'
      : new Intl.DateTimeFormat([], { dateStyle: 'medium', timeStyle: 'short' }).format(date.value) +
        (repeat.value === 'once' ? '' : ', repeat ' + repeat.value.replace('-', ' ')),
    'message-reminders':
      new Intl.DateTimeFormat([], { dateStyle: 'medium', timeStyle: 'short' }).format(step.reminder?.date) +
      (step.reminder?.message ? ', ' : '') +
      step.reminder?.message,
    autofill: autofill.enabled
      ? {
          RefillAutofill: 'Refill the cart from the last order',
          CategoryAutofill: 'Match the number of items in each category'
        }[autofill.type]
      : 'Disabled',
    autocharge: autocharge.enabled
      ? new Intl.DateTimeFormat([], { dateStyle: 'medium', timeStyle: 'short' }).format(autocharge.date)
      : 'Disabled',
    'workflow-name': workflowName.value,
    trigger: triggerType.value === 'ReceivedSmsWorkflowTrigger' ? 'Receive SMS' : triggerType.value,
    conditions: conditions.value.length + ' condition' + (conditions.value.length === 1 ? '' : 's'),
    actions: actions.value.length + ' action' + (actions.value.length === 1 ? '' : 's')
  })[step.id]

watch(
  selectedAudiences,
  () => {
    for (const audience of selectedAudiences.value)
      if (!detail(audience)) api.call('GET', `audiences/${audience.id}?included=audience_detail`)
  },
  { deep: true }
)

// Who the message goes out to, shown on the preview step. Counted by the
// server with the send's own query, so lists overlapping, the list segment
// and opted out customers are all accounted for.
const recipientCounts = ref(null)
const recipientRows = computed(() => listRecipientRows(selectedAudiences.value, recipientCounts.value))
const recipientSummaryText = computed(() => recipientSummary(recipientCounts.value))
const recipientCountsRequest = computed(() =>
  type.value === 'message' && steps.value[currentStep.value]?.id === 'preview' && selectedAudiences.value.length
    ? recipientCountsEndpoint(selectedAudiences.value, segment.value)
    : null
)

watch(recipientCountsRequest, endpoint => {
  recipientCounts.value = null
  if (!endpoint) return
  api
    .call('GET', endpoint, {}, { receive: false })
    .then(response => {
      // a slower, older request must not overwrite the current one
      if (recipientCountsRequest.value === endpoint) recipientCounts.value = response.data.data.attributes
    })
    .catch(() => {})
})

const load = id => {
  hasUnsavedChanges.value = false
  const promises = []

  if (type.value !== 'workflow') {
    promises.push(
      api.call('GET', 'membership_tiers?included=audience.audience_detail'),
      api.call('GET', 'stores?included=fulfillment_method_store_pairs')
    )
  } else {
    promises.push(api.call('GET', 'membership_tiers?included=none'))
  }
  if (id === 'new') {
    if (route.query.list && type.value !== 'workflow') {
      promises.push(
        api.call('GET', `audiences/${route.query.list}?included=audience_detail`).then(() => {
          selectedAudiences.value.push(mapRelationship({ type: 'audience', id: route.query.list }))
        })
      )
    }
    selectedAudiences.value = []
    segment.value = route.query.segment ?? 'all'
    message.value = null
    attachmentType.value = 'image'
    now.value = true
    date.value = null
    repeat.value = 'once'
    name.value = ''
    workflowName.value = ''
    triggerType.value = 'ReceivedSmsWorkflowTrigger'
    conditions.value = [{ type: 'TextWorkflowCondition', operator: 'is_exactly', value: '' }]
    actions.value = [{ type: 'SendSmsWorkflowAction', config: { message: '' }, order: 1 }]
    currentStep.value = 0
  } else {
    if (type.value === 'message') {
      promises.push(
        api
          .call('GET', `message_automations/${id}?included=automation_scheduler,audiences,message_template.attachments`)
          .then(() => {
            selectedAudiences.value = mapRelationships(automation.value.relationships.audiences.data)
            segment.value = automation.value.attributes.audience_list ?? 'all'
            message.value = template.value.attributes.body
            attachmentType.value = template.value.attributes.attach_vcard ? 'vcard' : 'image'
            now.value = false
            date.value = new Date(scheduler.value?.attributes.datetime)
            repeat.value = scheduler.value?.attributes.frequency ?? 'once'
            name.value = automation.value.attributes.name
            currentStep.value = steps.value.findIndex(x => x.id === 'preview')
          })
      )
    } else if (type.value === 'workflow') {
      promises.push(
        api
          .call('GET', `workflows/${id}?included=workflow_triggers.workflow_conditions,workflow_actions`)
          .then(() => {
            const workflow = mapRelationship({ type: 'workflow', id })

            if (!workflow || !workflow.attributes) {
              console.error('Workflow not found or missing attributes')
              return
            }

            workflowName.value = workflow.attributes.name || ''

            const triggers = mapRelationships(workflow.relationships?.workflow_triggers?.data || [])
            if (triggers.length > 0 && triggers[0]?.attributes) {
              const trigger = triggers[0]
              triggerType.value = trigger.attributes.type || 'ReceivedSmsWorkflowTrigger'

              const conditionsData = mapRelationships(trigger.relationships?.workflow_conditions?.data || [])
              conditions.value = conditionsData
                .filter(condition => condition?.attributes)
                .map(condition => ({
                  type: condition.attributes.type,
                  operator: condition.attributes.operator,
                  value: condition.attributes.value
                }))

              if (conditions.value.length === 0) {
                conditions.value = [{ type: 'TextWorkflowCondition', operator: 'is_exactly', value: '' }]
              }
            } else {
              triggerType.value = 'ReceivedSmsWorkflowTrigger'
              conditions.value = [{ type: 'TextWorkflowCondition', operator: 'is_exactly', value: '' }]
            }

            const actionsData = mapRelationships(workflow.relationships?.workflow_actions?.data || [])
            if (actionsData.length > 0) {
              actions.value = actionsData
                .filter(action => action?.attributes)
                .map(action => ({
                  type: action.attributes.type,
                  config: workflowActionConfigFromServer(action.attributes.config),
                  order: action.attributes.order || 1
                }))
            } else {
              actions.value = [{ type: 'SendSmsWorkflowAction', config: { message: '' }, order: 1 }]
            }

            currentStep.value = steps.value.findIndex(x => x.id === 'preview')
          })
          .catch(error => {
            console.error('Error loading workflow:', error)
            workflowName.value = ''
            triggerType.value = 'ReceivedSmsWorkflowTrigger'
            conditions.value = [{ type: 'TextWorkflowCondition', operator: 'is_exactly', value: '' }]
            actions.value = [{ type: 'SendSmsWorkflowAction', config: { message: '' }, order: 1 }]
          })
      )
    } else {
      promises.push(
        api
          .call(
            'GET',
            `bottle_cycles/${id}?included=${[
              'audiences',
              'bottle_cycle_audience_pairs',
              'bottle_reminder_automations',
              'bottle_reminder_automations.automation_scheduler',
              'bottle_reminder_automations.message_template',
              'bottle_reminder_automations.message_template.attachments',
              'fulfillment_availabilities',
              'bottle_autofill_automation',
              'bottle_autofill_automation.automation_fields',
              'bottle_autocharge_automation',
              'bottle_autocharge_automation.automation_scheduler'
            ].join(',')}`
          )
          .then(() => {
            selectedAudiences.value = mapRelationships(drop.value.relationships.audiences.data)
            store.value = drop.value.relationships.store.data?.id
            days.value = mapRelationships(drop.value.relationships.fulfillment_availabilities.data).map(
              x => x.attributes.date
            )
            reminders.value = mapRelationships(drop.value.relationships.bottle_reminder_automations.data).map(x => ({
              message: mapRelationship(x.relationships.message_template.data)?.attributes.body,
              date: new Date(mapRelationship(x.relationships.automation_scheduler.data)?.attributes.datetime),
              completed: x.attributes.status === 'completed'
            }))
            const fields = mapRelationships(
              mapRelationship(drop.value.relationships.bottle_autofill_automation.data)?.relationships.automation_fields
                .data
            )
            autofill.enabled = fields.some(x => x.attributes.key === 'type')
            autofill.type = fields.find(x => x.attributes.key === 'type')?.attributes.text_value
            autofill.reminders = fields.some(
              x => x.attributes.key === 'run_before' && x.attributes.text_value === 'reminders'
            )
            autofill.autocharge = fields.some(
              x => x.attributes.key === 'run_before' && x.attributes.text_value === 'autocharge'
            )
            const autochargeAutomation = mapRelationship(drop.value.relationships.bottle_autocharge_automation.data)
            autocharge.enabled = !!autochargeAutomation
            if (autochargeAutomation) {
              const scheduler = mapRelationship(autochargeAutomation.relationships.automation_scheduler.data)
              autocharge.date = new Date(scheduler.attributes.datetime)
            }
            currentStep.value = steps.value.findIndex(x => x.id === 'preview')
          })
      )
    }
  }
  Promise.all(promises).then(() => {
    loading.value = false
  })
}
load(route.params.id)
onBeforeRouteUpdate(to => {
  loading.value = true
  type.value = to.meta.automation
  load(to.params.id)
})
onBeforeRouteLeave(to => {
  if (!to.meta.automation) return
  loading.value = true
  type.value = to.meta.automation
  load(to.params.id)
})

const backToList = kind => () => router.replace(AUTOMATION_LISTS[kind])

// The API refuses a message scheduled outside the send window with the reason
// in `errors`; without this the request failed silently and the page just stayed.
const showSaveProblem = error =>
  showToast(error?.response?.data?.errors?.[0] || 'That message could not be saved.', { type: 'error' })

const send = () => {
  if (!canCreateAutomations.value) return
  if (type.value === 'message') {
    api
      .call('POST', 'message_automations', {
        automation: {
          type: 'MessageAutomation',
          name: name.value,
          audience_automation_pairs_attributes: selectedAudiences.value.map(x => ({ audience_id: x.id })),
          audience_list: segment.value,
          automation_scheduler_attributes: {
            frequency: repeat.value,
            datetime: now.value ? new Date().toISOString() : date.value
          },
          message_template_attributes: {
            body: message.value,
            attach_vcard: attachmentType.value === 'vcard',
            attachments_attributes: attachmentType.value === 'vcard' ? [] : images.value
          }
        }
      })
      .then(backToList('message'))
      .catch(showSaveProblem)
  } else if (type.value === 'workflow') {
    api
      .call('POST', 'workflows', {
        workflow: {
          name: workflowName.value,
          workflow_triggers_attributes: [
            {
              type: triggerType.value,
              workflow_conditions_attributes: conditions.value.map(condition => ({
                type: condition.type,
                operator: condition.operator,
                value: condition.value
              }))
            }
          ],
          workflow_actions_attributes: actions.value.map(action => ({
            type: action.type,
            config: action.config,
            order: action.order
          }))
        }
      })
      .then(backToList('workflow'))
  } else {
    api
      .call('POST', 'bottle_cycles', {
        bottle_cycle: {
          store_id: store.value,
          bottle_cycle_audience_pairs_attributes: selectedAudiences.value.map(x => ({ audience_id: x.id })),
          bottle_reminder_automations_attributes: reminders.value.map(x => ({
            automation_scheduler_attributes: {
              frequency: 'once',
              datetime: x.date
            },
            message_template_attributes: { body: x.message }
          })),
          fulfillment_availabilities_attributes: days.value.map(x => ({ date: x })),
          bottle_autofill_automation_attributes: {
            automation_fields_attributes: [
              autofill.enabled && {
                key: 'type',
                text_value: autofill.type
              },
              autofill.reminders && {
                key: 'run_before',
                text_value: 'reminders'
              },
              autofill.autocharge && {
                key: 'run_before',
                text_value: 'autocharge'
              }
            ]
          },
          bottle_autocharge_automation_attributes: autocharge.enabled
            ? { automation_scheduler_attributes: { datetime: autocharge.date } }
            : undefined
        }
      })
      .then(backToList('drop'))
  }
}

const save = () => {
  if (!canUpdateAutomations.value) return
  if (type.value === 'message') {
    api
      .call('PUT', `message_automations/${route.params.id}`, {
        automation: {
          name: name.value,
          audience_automation_pairs_attributes: [
            ...automation.value.relationships.audience_automation_pairs.data.map(x => ({ id: x.id, _destroy: true })),
            ...selectedAudiences.value.map(x => ({ audience_id: x.id }))
          ],
          audience_list: segment.value,
          automation_scheduler_attributes: {
            frequency: repeat.value,
            datetime: now.value ? new Date().toISOString() : date.value
          },
          message_template_attributes: {
            body: message.value,
            attach_vcard: attachmentType.value === 'vcard',
            attachments_attributes: attachmentType.value === 'vcard' ? [] : images.value
          }
        }
      })
      .catch(showSaveProblem)
  } else if (type.value === 'workflow') {
    const workflow = mapRelationship({ type: 'workflow', id: route.params.id })

    if (!workflow) {
      console.error('Workflow not found for update')
      return
    }

    const existingTriggers = mapRelationships(workflow?.relationships?.workflow_triggers?.data || [])
    const existingActions = mapRelationships(workflow?.relationships?.workflow_actions?.data || [])
    const triggersAttributes = []

    if (existingTriggers.length > 0 && existingTriggers[0]?.attributes) {
      const existingTrigger = existingTriggers[0]
      const existingConditions = mapRelationships(existingTrigger.relationships?.workflow_conditions?.data || [])

      triggersAttributes.push({
        id: existingTrigger.id,
        type: triggerType.value,
        workflow_conditions_attributes: [
          ...existingConditions
            .filter(condition => condition?.id)
            .slice(conditions.value.length)
            .map(condition => ({ id: condition.id, _destroy: true })),
          ...conditions.value.map((condition, index) => {
            const existingCondition = existingConditions[index]
            if (existingCondition?.id) {
              return {
                id: existingCondition.id,
                type: condition.type,
                operator: condition.operator,
                value: condition.value
              }
            } else {
              return {
                type: condition.type,
                operator: condition.operator,
                value: condition.value
              }
            }
          })
        ]
      })

      if (existingTriggers.length > 1) {
        triggersAttributes.push(...existingTriggers.slice(1).map(trigger => ({ id: trigger.id, _destroy: true })))
      }
    } else {
      triggersAttributes.push({
        type: triggerType.value,
        workflow_conditions_attributes: conditions.value.map(condition => ({
          type: condition.type,
          operator: condition.operator,
          value: condition.value
        }))
      })
    }

    const actionsAttributes = []

    actions.value.forEach((action, index) => {
      const existingAction = existingActions[index]
      if (existingAction?.id) {
        actionsAttributes.push({
          id: existingAction.id,
          type: action.type,
          config: action.config,
          order: action.order
        })
      } else {
        actionsAttributes.push({
          type: action.type,
          config: action.config,
          order: action.order
        })
      }
    })

    if (existingActions.length > actions.value.length) {
      actionsAttributes.push(
        ...existingActions
          .filter(action => action?.id)
          .slice(actions.value.length)
          .map(action => ({ id: action.id, _destroy: true }))
      )
    }

    api.call('PUT', `workflows/${route.params.id}`, {
      workflow: {
        name: workflowName.value,
        workflow_triggers_attributes: triggersAttributes,
        workflow_actions_attributes: actionsAttributes
      }
    })
  } else {
    api.call('PUT', `bottle_cycles/${route.params.id}`, {
      bottle_cycle: {
        store_id: store.value,
        bottle_cycle_audience_pairs_attributes: selectedAudiences.value.map(x => ({ audience_id: x.id })),
        bottle_cycle_audience_pairs_attributes: [
          ...drop.value.relationships.bottle_cycle_audience_pairs.data.map(x => ({ id: x.id, _destroy: true })),
          ...selectedAudiences.value.map(x => ({ audience_id: x.id }))
        ],
        fulfillment_availabilities_attributes: [
          ...drop.value.relationships.fulfillment_availabilities.data.map(x => ({ id: x.id, _destroy: true })),
          ...days.value.map(x => ({ date: x }))
        ],
        bottle_reminder_automations_attributes: [
          ...drop.value.relationships.bottle_reminder_automations.data.map(x => ({ id: x.id, _destroy: true })),
          ...reminders.value
            .filter(x => !x.completed)
            .map(x => ({
              automation_scheduler_attributes: {
                frequency: 'once',
                datetime: x.date
              },
              message_template_attributes: { body: x.message }
            }))
        ],
        bottle_autofill_automation_attributes: {
          automation_fields_attributes: [
            ...mapRelationship(
              drop.value.relationships.bottle_autofill_automation.data
            )?.relationships.automation_fields.data.map(x => ({ id: x.id, _destroy: true })),
            autofill.enabled && {
              key: 'type',
              text_value: autofill.type
            },
            autofill.reminders && {
              key: 'run_before',
              text_value: 'reminders'
            },
            autofill.autocharge && {
              key: 'run_before',
              text_value: 'autocharge'
            }
          ].filter(Boolean)
        },
        bottle_autocharge_automation_attributes: {
          ...(autocharge.enabled
            ? {
                automation_scheduler_attributes: {
                  datetime: autocharge.date
                }
              }
            : {
                _destroy: true
              })
        }
      }
    })
  }
  hasUnsavedChanges.value = false
}

const autoChargeConfirmOpen = ref(false)
const pendingAutochargeSubmit = ref(null)

const autoChargeConfirmAudiences = computed(() => audienceConfirmRows(selectedAudiences.value, detail))

// For a drop with auto-charge enabled, require the acknowledgement modal before the
// submit runs. Otherwise run it immediately.
const runWithAutochargeGuard = proceed => {
  if (type.value === 'drop' && autocharge.enabled) {
    pendingAutochargeSubmit.value = proceed
    autoChargeConfirmOpen.value = true
  } else {
    proceed()
  }
}

// Call-site entry points (used by the template in place of send/save directly).
const submitCreate = () => runWithAutochargeGuard(send)
const submitSave = () => runWithAutochargeGuard(save)

const confirmAutocharge = () => {
  autoChargeConfirmOpen.value = false
  const proceed = pendingAutochargeSubmit.value
  pendingAutochargeSubmit.value = null
  if (proceed) proceed()
}

const cancelAutocharge = () => {
  autoChargeConfirmOpen.value = false
  pendingAutochargeSubmit.value = null
}

const deleteAutomation = () => {
  if (!canDeleteAutomations.value) return
  if (type.value === 'message') {
    if (!confirm('Delete this automation?')) return
    api.call('DELETE', `message_automations/${route.params.id}`).then(backToList('message'))
  } else if (type.value === 'workflow') {
    if (!confirm('Delete this workflow?')) return
    api.call('DELETE', `workflows/${route.params.id}`).then(backToList('workflow'))
  } else {
    if (!confirm('Delete this drop?')) return
    api.call('DELETE', `bottle_cycles/${route.params.id}`).then(backToList('drop'))
  }
}

return (_ctx, _cache) => {
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_router_link = _resolveComponent("router-link")
  const _component_SecondaryTop = _resolveComponent("SecondaryTop")
  const _component_SaveBar = _resolveComponent("SaveBar")
  const _component_NeueToggle = _resolveComponent("NeueToggle")
  const _component_InlineSearchSelect = _resolveComponent("InlineSearchSelect")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_FulfillmentSlotCalendar = _resolveComponent("FulfillmentSlotCalendar")
  const _component_InputArea = _resolveComponent("InputArea")
  const _component_ImageUploaderNeue = _resolveComponent("ImageUploaderNeue")
  const _component_InputField = _resolveComponent("InputField")
  const _component_NeueLoading = _resolveComponent("NeueLoading")
  const _component_PageFooter = _resolveComponent("PageFooter")
  const _component_SecondaryNav = _resolveComponent("SecondaryNav")
  const _component_AutoChargeConfirmModal = _resolveComponent("AutoChargeConfirmModal")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SecondaryNav, null, {
      top: _withCtx(() => [
        _createVNode(_component_SecondaryTop, {
          text: "Automation",
          "save-status": true
        }, {
          right: _withCtx(() => [
            (type.value === 'drop')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: `/store/drops/${_unref(route).params.id}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_NeueButton, { type: "secondary" }, {
                      default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                        _createElementVNode("span", { class: "hidden sm:inline" }, "Go to the old version of this page", -1),
                        _createElementVNode("span", { class: "inline sm:hidden" }, "Go to old version", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (existing.value && canUpdateAutomations.value)
          ? (_openBlock(), _createBlock(_component_SaveBar, {
              key: 0,
              "has-unsaved-changes": hasUnsavedChanges.value,
              onOnDiscard: _cache[0] || (_cache[0] = $event => (load(_unref(route).params.id))),
              onOnSave: submitSave
            }, null, 8, ["has-unsaved-changes"]))
          : _createCommentVNode("", true)
      ]),
      main: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_NeueLoading, { loading: loading.value }, {
              default: _withCtx(() => [
                _createElementVNode("nav", _hoisted_3, [
                  _createElementVNode("ol", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps.value, (step, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: i,
                        class: _normalizeClass([i !== steps.value.length - 1 && i !== currentStep.value ? 'pb-10' : '', 'relative'])
                      }, [
                        (currentStep.value > i)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (i !== steps.value.length - 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", {
                                class: "group relative flex items-center cursor-pointer",
                                onClick: $event => (currentStep.value = i)
                              }, [
                                _createElementVNode("span", _hoisted_7, [
                                  _createElementVNode("span", _hoisted_8, [
                                    _createVNode(_unref(CheckIcon), {
                                      class: "h-5 w-5 text-white",
                                      "aria-hidden": "true"
                                    })
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_9, [
                                  _createElementVNode("span", _hoisted_10, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(step.name), 1),
                                    (step.reminder?.completed)
                                      ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                          key: 0,
                                          class: "h-5 w-5",
                                          "aria-hidden": "true"
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("span", _hoisted_12, _toDisplayString(stepPreview(step)), 1)
                                ])
                              ], 8, _hoisted_6)
                            ], 64))
                          : (currentStep.value === i)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (i !== steps.value.length - 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_14, [
                                  _cache[87] || (_cache[87] = _createElementVNode("span", {
                                    class: "flex h-9 items-center",
                                    "aria-hidden": "true"
                                  }, [
                                    _createElementVNode("span", { class: "relative z-10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-600 bg-white" }, [
                                      _createElementVNode("span", { class: "h-2.5 w-2.5 rounded-full bg-blue-600" })
                                    ])
                                  ], -1)),
                                  _createElementVNode("span", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("span", _hoisted_17, _toDisplayString(step.name), 1),
                                      (step.reminder?.completed)
                                        ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                            key: 0,
                                            class: "h-5 w-5 text-blue-600",
                                            "aria-hidden": "true"
                                          }))
                                        : _createCommentVNode("", true),
                                      (step.id === 'autofill')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                            _createVNode(_component_NeueToggle, {
                                              modelValue: autofill.enabled,
                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((autofill.enabled) = $event)),
                                              disabled: !canUpdateAutomations.value,
                                              onChange: _cache[2] || (_cache[2] = $event => (hasUnsavedChanges.value = true))
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'autocharge')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createVNode(_component_NeueToggle, {
                                              modelValue: autocharge.enabled,
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((autocharge.enabled) = $event)),
                                              disabled: !canUpdateAutomations.value,
                                              onChange: _cache[4] || (_cache[4] = $event => (hasUnsavedChanges.value = true))
                                            }, null, 8, ["modelValue", "disabled"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      (step.id === 'type')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["flex flex-col gap-y-2", (existing.value || !canUpdateAutomations.value) && 'opacity-50 pointer-events-none'])
                                            }, [
                                              _createElementVNode("div", _hoisted_22, [
                                                _createElementVNode("input", {
                                                  id: "type-1",
                                                  type: "radio",
                                                  name: "type",
                                                  class: "mr-2 cursor-pointer",
                                                  checked: type.value === 'message',
                                                  onInput: _cache[5] || (_cache[5] = $event => (type.value = 'message'))
                                                }, null, 40, _hoisted_23),
                                                _cache[56] || (_cache[56] = _createElementVNode("label", { for: "type-1" }, "Message", -1))
                                              ]),
                                              _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("input", {
                                                  id: "type-2",
                                                  type: "radio",
                                                  name: "type",
                                                  class: "mr-2 cursor-pointer",
                                                  checked: type.value === 'drop',
                                                  onInput: _cache[6] || (_cache[6] = $event => (type.value = 'drop'))
                                                }, null, 40, _hoisted_25),
                                                _cache[57] || (_cache[57] = _createElementVNode("label", { for: "type-2" }, "Drop", -1))
                                              ]),
                                              _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("input", {
                                                  id: "type-3",
                                                  type: "radio",
                                                  name: "type",
                                                  class: "mr-2 cursor-pointer",
                                                  checked: type.value === 'workflow',
                                                  onInput: _cache[7] || (_cache[7] = $event => (type.value = 'workflow'))
                                                }, null, 40, _hoisted_27),
                                                _cache[58] || (_cache[58] = _createElementVNode("label", { for: "type-3" }, "Workflow", -1))
                                              ])
                                            ], 2)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'lists')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                            (selectedAudiences.value.length)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                  _cache[59] || (_cache[59] = _createElementVNode("div", { class: "mb-1.5 font-medium text-gray-700" }, "Selected lists", -1)),
                                                  _createElementVNode("div", _hoisted_30, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedAudiences.value, (audience) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass(["relative rounded-lg border bg-white pl-6 py-4 shadow-sm focus:outline-none flex justify-between xl:mr-0 mr-0.5 border-blue-600 ring-2 ring-blue-600 pr-4", canUpdateAutomations.value ? 'cursor-pointer' : 'cursor-not-allowed opacity-50']),
                                                        onClick: $event => (canUpdateAutomations.value && toggleAudience(audience))
                                                      }, [
                                                        _createElementVNode("span", _hoisted_32, [
                                                          _createElementVNode("span", _hoisted_33, [
                                                            _createElementVNode("span", _hoisted_34, _toDisplayString(audience.attributes.audience_name), 1)
                                                          ]),
                                                          _createElementVNode("span", _hoisted_35, [
                                                            _createElementVNode("span", _hoisted_36, _toDisplayString(detail(audience)?.attributes.number_of_contacts), 1),
                                                            _createElementVNode("span", _hoisted_37, " member" + _toDisplayString(detail(audience)?.attributes.number_of_contacts === 1 ? '' : 's'), 1)
                                                          ])
                                                        ]),
                                                        _createVNode(_unref(CheckCircleIcon), {
                                                          class: "ml-4 h-5 w-5 text-blue-600 flex-shrink-0",
                                                          "aria-hidden": "true"
                                                        })
                                                      ], 10, _hoisted_31))
                                                    }), 256))
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (tiersAudiences.value.filter(x => !selectedAudiences.value.some(y => x.id === y.id)).length)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                  _cache[60] || (_cache[60] = _createElementVNode("div", { class: "mb-1.5 font-medium text-gray-700" }, "Suggested lists", -1)),
                                                  _createElementVNode("div", _hoisted_39, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiersAudiences.value.filter(
                                    x => !selectedAudiences.value.some(y => x.id === y.id)
                                  ), (audience) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass(["relative rounded-lg border bg-white pl-6 py-4 shadow-sm focus:outline-none flex justify-between xl:mr-0 mr-0.5 border-gray-300 pr-6", canUpdateAutomations.value ? 'cursor-pointer' : 'cursor-not-allowed opacity-50']),
                                                        onClick: $event => (canUpdateAutomations.value && toggleAudience(audience))
                                                      }, [
                                                        _createElementVNode("span", _hoisted_41, [
                                                          _createElementVNode("span", _hoisted_42, [
                                                            _createElementVNode("span", _hoisted_43, _toDisplayString(audience.attributes.audience_name), 1)
                                                          ]),
                                                          _createElementVNode("span", _hoisted_44, [
                                                            _createElementVNode("span", _hoisted_45, _toDisplayString(detail(audience)?.attributes.number_of_contacts), 1),
                                                            _createElementVNode("span", _hoisted_46, " member" + _toDisplayString(detail(audience)?.attributes.number_of_contacts === 1 ? '' : 's'), 1)
                                                          ])
                                                        ])
                                                      ], 10, _hoisted_40))
                                                    }), 256))
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            _cache[61] || (_cache[61] = _createElementVNode("div", { class: "mt-4 mb-1.5 font-medium text-gray-700" }, "Search for other lists", -1)),
                                            _createVNode(_component_InlineSearchSelect, {
                                              "helper-text": { typingPrompt: 'Add lists', noResult: 'No lists found' },
                                              "search-endpoint": "audiences/search?included=none",
                                              "search-request": { search: { text: audienceQuery.value } },
                                              editable: canUpdateAutomations.value,
                                              onOnSearch: _cache[8] || (_cache[8] = x => (audienceQuery.value = x)),
                                              onOnResults: _cache[9] || (_cache[9] = x => (audienceResults.value = x))
                                            }, {
                                              searchResults: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(audienceResults.value, (item) => {
                                                  return (_openBlock(), _createBlock(_unref(MenuItem), {
                                                    key: item.id
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("button", {
                                                        class: "group rounded-md w-full px-2 py-2 text-sm text-left hover:bg-gray-100 duration-200 transition-colors text-gray-700",
                                                        onClick: $event => (toggleAudience(item))
                                                      }, _toDisplayString(item.attributes.audience_name), 9, _hoisted_47)
                                                    ]),
                                                    _: 2
                                                  }, 1024))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["search-request", "editable"]),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["mt-4", !canUpdateAutomations.value && 'cursor-not-allowed'])
                                            }, [
                                              _createVNode(_component_SelectInput, {
                                                modelValue: segment.value,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((segment).value = $event)),
                                                name: "List segment",
                                                disabled: !canUpdateAutomations.value,
                                                class: _normalizeClass(!canUpdateAutomations.value && 'cursor-not-allowed'),
                                                options: [
                                  { name: 'All contacts on the list', value: 'all' },
                                  { name: 'Contacts with a paid order', value: 'orders' },
                                  {
                                    name: 'Contacts with an order or who will be charged',
                                    value: 'orders-and-will-be-charged'
                                  },
                                  { name: 'Contacts with an unpaid cart', value: 'carts' }
                                ],
                                                onInput: _cache[11] || (_cache[11] = $event => (hasUnsavedChanges.value = true))
                                              }, null, 8, ["modelValue", "disabled", "class"])
                                            ], 2)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'store')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 2,
                                            class: _normalizeClass(!canUpdateAutomations.value && 'cursor-not-allowed')
                                          }, [
                                            _createVNode(_component_SelectInput, {
                                              modelValue: store.value,
                                              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((store).value = $event)),
                                              placeholder: "Default store for this drop",
                                              disabled: !canUpdateAutomations.value,
                                              class: _normalizeClass(!canUpdateAutomations.value && 'cursor-not-allowed'),
                                              options: stores.value.map(x => ({ name: x.attributes.store_name, value: x.id })),
                                              onInput: _cache[13] || (_cache[13] = $event => (hasUnsavedChanges.value = true))
                                            }, null, 8, ["modelValue", "disabled", "class", "options"])
                                          ], 2))
                                        : _createCommentVNode("", true),
                                      (step.id === 'fulfillment')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                            _cache[62] || (_cache[62] = _createElementVNode("div", { class: "mb-1.5 font-medium text-gray-700" }, "Upcoming production days", -1)),
                                            _createElementVNode("div", _hoisted_49, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(upcomingDays.value, (day) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: _normalizeClass(["w-24 h-20 leading-6 border rounded-lg flex flex-col items-center justify-center relative", [
                                  days.value.includes(day) && 'border-2 border-black',
                                  canUpdateAutomations.value ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'
                                ]]),
                                                  onClick: $event => (canUpdateAutomations.value && toggleDay(day))
                                                }, [
                                                  (days.value.includes(day))
                                                    ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
                                                        key: 0,
                                                        class: "absolute -top-2.5 -right-2.5 bg-white cursor-pointer h-5 w-5 hover:text-black"
                                                      }))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("div", _hoisted_51, _toDisplayString(new Intl.DateTimeFormat([], { weekday: 'long' }).format(_unref(serverDayToDateObject)(day))), 1),
                                                  _createElementVNode("div", _hoisted_52, _toDisplayString(new Intl.DateTimeFormat([], { day: 'numeric' }).format(_unref(serverDayToDateObject)(day))), 1),
                                                  _createElementVNode("div", _hoisted_53, _toDisplayString(new Intl.DateTimeFormat([], { month: 'short' }).format(_unref(serverDayToDateObject)(day))), 1)
                                                ], 10, _hoisted_50))
                                              }), 256))
                                            ]),
                                            _cache[63] || (_cache[63] = _createElementVNode("div", { class: "mb-1.5 font-medium text-gray-700" }, "Selected production days", -1)),
                                            _createElementVNode("div", _hoisted_54, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(days.value, (day) => {
                                                return (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                                  (canUpdateAutomations.value)
                                                    ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                                                        key: 0,
                                                        class: "absolute -top-2.5 -right-2.5 bg-white cursor-pointer h-5 w-5 hover:text-black",
                                                        onClick: $event => (toggleDay(day))
                                                      }, null, 8, ["onClick"]))
                                                    : _createCommentVNode("", true),
                                                  _createElementVNode("div", _hoisted_56, _toDisplayString(new Intl.DateTimeFormat([], { weekday: 'long' }).format(_unref(serverDayToDateObject)(day))), 1),
                                                  _createElementVNode("div", _hoisted_57, _toDisplayString(new Intl.DateTimeFormat([], { day: 'numeric' }).format(_unref(serverDayToDateObject)(day))), 1),
                                                  _createElementVNode("div", _hoisted_58, _toDisplayString(new Intl.DateTimeFormat([], { month: 'short' }).format(_unref(serverDayToDateObject)(day))), 1)
                                                ]))
                                              }), 256)),
                                              (!days.value.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_59))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createVNode(_component_FulfillmentSlotCalendar, {
                                              "external-days": days.value,
                                              "onUpdate:externalDays": [
                                                _cache[14] || (_cache[14] = $event => ((days).value = $event)),
                                                _cache[15] || (_cache[15] = $event => (hasUnsavedChanges.value = true))
                                              ],
                                              slots: slots.value,
                                              store: _unref(mapRelationship)({ type: 'store', id: store.value }),
                                              editable: canUpdateAutomations.value,
                                              "selected-day": selectedDay.value,
                                              onGetSlots: getSlots
                                            }, null, 8, ["external-days", "slots", "store", "editable", "selected-day"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'message')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                            _createVNode(_component_InputArea, {
                                              modelValue: message.value,
                                              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((message).value = $event)),
                                              name: "Message",
                                              "validate-profanity": true,
                                              onInput: _cache[17] || (_cache[17] = $event => (hasUnsavedChanges.value = true)),
                                              onValidationResponse: _cache[18] || (_cache[18] = response => (messageValidationPassed.value = response))
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_SelectInput, {
                                              modelValue: attachmentType.value,
                                              "onUpdate:modelValue": [
                                                _cache[19] || (_cache[19] = $event => ((attachmentType).value = $event)),
                                                _cache[20] || (_cache[20] = $event => (hasUnsavedChanges.value = true))
                                              ],
                                              class: "mt-4",
                                              name: "Attachment",
                                              options: [
                                { name: 'Image', value: 'image' },
                                { name: 'vCard (contact details)', value: 'vcard' }
                              ]
                                            }, null, 8, ["modelValue"]),
                                            (attachmentType.value === 'image')
                                              ? (_openBlock(), _createBlock(_component_ImageUploaderNeue, {
                                                  key: 0,
                                                  class: "mt-4",
                                                  files: existingImages.value,
                                                  retained: true,
                                                  editable: canUpdateAutomations.value,
                                                  "max-file-size": 2 * 1024 * 1024,
                                                  onChange: changeImages
                                                }, null, 8, ["files", "editable"]))
                                              : _createCommentVNode("", true),
                                            (attachmentType.value === 'vcard')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_61, " Your contact card will be automatically attached to this message. "))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'message-reminders')
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 5,
                                            class: _normalizeClass(step.reminder.completed && 'pointer-events-none opacity-50')
                                          }, [
                                            _createVNode(_component_InputArea, {
                                              modelValue: step.reminder.message,
                                              "onUpdate:modelValue": $event => ((step.reminder.message) = $event),
                                              name: "Message",
                                              "validate-profanity": true,
                                              disabled: !canUpdateAutomations.value,
                                              onInput: _cache[21] || (_cache[21] = $event => (hasUnsavedChanges.value = true)),
                                              onValidationResponse: response => (step.reminder.messageValidationPassed = response)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onValidationResponse"]),
                                            _createVNode(_unref(DatePicker), {
                                              modelValue: step.reminder.date,
                                              "onUpdate:modelValue": [
                                                $event => ((step.reminder.date) = $event),
                                                _cache[22] || (_cache[22] = $event => (hasUnsavedChanges.value = true))
                                              ],
                                              class: "mt-3",
                                              mode: "dateTime",
                                              "min-date": step.reminder.completed ? 0 : new Date()
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "min-date"])
                                          ], 2))
                                        : _createCommentVNode("", true),
                                      (step.id === 'time' && !existing.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["flex flex-col gap-y-2", !canUpdateAutomations.value && 'opacity-50 pointer-events-none'])
                                            }, [
                                              _createElementVNode("div", _hoisted_63, [
                                                _createElementVNode("input", {
                                                  id: "time-now",
                                                  type: "radio",
                                                  name: "time",
                                                  class: "mr-2 cursor-pointer",
                                                  checked: now.value,
                                                  onInput: _cache[23] || (_cache[23] = $event => (now.value = true))
                                                }, null, 40, _hoisted_64),
                                                _cache[64] || (_cache[64] = _createElementVNode("label", { for: "time-now" }, "Send immediately", -1))
                                              ]),
                                              _createElementVNode("div", _hoisted_65, [
                                                _createElementVNode("input", {
                                                  id: "time-schedule",
                                                  type: "radio",
                                                  name: "time",
                                                  class: "mr-2 cursor-pointer",
                                                  checked: !now.value,
                                                  onInput: _cache[24] || (_cache[24] = $event => (now.value = false))
                                                }, null, 40, _hoisted_66),
                                                _cache[65] || (_cache[65] = _createElementVNode("label", { for: "time-schedule" }, "Schedule a time to send", -1))
                                              ])
                                            ], 2)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'time' && !now.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                            _createVNode(_unref(DatePicker), {
                                              modelValue: date.value,
                                              "onUpdate:modelValue": [
                                                _cache[25] || (_cache[25] = $event => ((date).value = $event)),
                                                _cache[26] || (_cache[26] = $event => (hasUnsavedChanges.value = true))
                                              ],
                                              class: "mt-3",
                                              mode: "dateTime",
                                              "min-date": new Date()
                                            }, null, 8, ["modelValue", "min-date"]),
                                            _createElementVNode("div", _hoisted_68, [
                                              _createVNode(_component_NeueToggle, {
                                                class: "mb-2",
                                                name: "Repeat",
                                                "model-value": repeat.value !== 'once',
                                                "onUpdate:modelValue": _cache[27] || (_cache[27] = 
                                  e => {
                                    repeat.value = e ? 'daily' : 'once'
                                    hasUnsavedChanges.value = true
                                  }
                                )
                                              }, null, 8, ["model-value"]),
                                              (repeat.value !== 'once')
                                                ? (_openBlock(), _createBlock(_component_SelectInput, {
                                                    key: 0,
                                                    modelValue: repeat.value,
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => ((repeat).value = $event)),
                                                    options: [
                                  { name: 'Daily', value: 'daily' },
                                  { name: 'Weekly', value: 'weekly' },
                                  { name: 'Every other week', value: 'every-other-week' },
                                  { name: 'Monthly', value: 'monthly' },
                                  { name: 'Quarterly', value: 'quarterly' },
                                  { name: 'Yearly', value: 'yearly' }
                                ],
                                                    onInput: _cache[29] || (_cache[29] = $event => (hasUnsavedChanges.value = true))
                                                  }, null, 8, ["modelValue"]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'autofill' && autofill.enabled)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                            _createElementVNode("div", _hoisted_70, [
                                              _createVNode(_component_NeueToggle, {
                                                modelValue: autofill.reminders,
                                                "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => ((autofill.reminders) = $event)),
                                                name: "Run before reminders",
                                                disabled: !canUpdateAutomations.value,
                                                onChange: _cache[31] || (_cache[31] = $event => (hasUnsavedChanges.value = true))
                                              }, null, 8, ["modelValue", "disabled"]),
                                              _createVNode(_component_NeueToggle, {
                                                modelValue: autofill.autocharge,
                                                "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => ((autofill.autocharge) = $event)),
                                                name: "Run before autocharge",
                                                disabled: !canUpdateAutomations.value,
                                                onChange: _cache[33] || (_cache[33] = $event => (hasUnsavedChanges.value = true))
                                              }, null, 8, ["modelValue", "disabled"]),
                                              _createElementVNode("div", {
                                                class: _normalizeClass(!canUpdateAutomations.value && 'cursor-not-allowed')
                                              }, [
                                                _createVNode(_component_SelectInput, {
                                                  modelValue: autofill.type,
                                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => ((autofill.type) = $event)),
                                                  name: "Autofill type",
                                                  disabled: !canUpdateAutomations.value,
                                                  class: _normalizeClass(!canUpdateAutomations.value && 'cursor-not-allowed'),
                                                  options: [
                                    { name: 'Refill the cart from the last order', value: 'RefillAutofill' },
                                    { name: 'Match the number of items in each category', value: 'CategoryAutofill' }
                                  ],
                                                  onInput: _cache[35] || (_cache[35] = $event => (hasUnsavedChanges.value = true))
                                                }, null, 8, ["modelValue", "disabled", "class"])
                                              ], 2)
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'autocharge' && autocharge)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                            (autocharge.enabled)
                                              ? (_openBlock(), _createBlock(_unref(DatePicker), {
                                                  key: 0,
                                                  modelValue: autocharge.date,
                                                  "onUpdate:modelValue": [
                                                    _cache[36] || (_cache[36] = $event => ((autocharge.date) = $event)),
                                                    _cache[37] || (_cache[37] = $event => (hasUnsavedChanges.value = true))
                                                  ],
                                                  mode: "dateTime",
                                                  "min-date": new Date()
                                                }, null, 8, ["modelValue", "min-date"]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'workflow-name')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                            _createVNode(_component_InputField, {
                                              modelValue: workflowName.value,
                                              "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => ((workflowName).value = $event)),
                                              name: "Workflow Name",
                                              placeholder: "Enter workflow name",
                                              onInput: _cache[39] || (_cache[39] = $event => (hasUnsavedChanges.value = true))
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'trigger')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                            _createVNode(_component_SelectInput, {
                                              modelValue: triggerType.value,
                                              "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => ((triggerType).value = $event)),
                                              name: "Trigger Type",
                                              options: [{ name: 'Receive SMS', value: 'ReceivedSmsWorkflowTrigger' }],
                                              onInput: _cache[41] || (_cache[41] = $event => (hasUnsavedChanges.value = true))
                                            }, null, 8, ["modelValue"])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'conditions')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                            _createElementVNode("div", _hoisted_75, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conditions.value, (condition, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: index,
                                                  class: "border rounded-lg p-4"
                                                }, [
                                                  _createElementVNode("div", _hoisted_76, [
                                                    _createElementVNode("h4", _hoisted_77, "Condition " + _toDisplayString(index + 1), 1),
                                                    (conditions.value.length > 1 && canUpdateAutomations.value)
                                                      ? (_openBlock(), _createBlock(_component_NeueButton, {
                                                          key: 0,
                                                          type: "red",
                                                          onClick: $event => (deleteCondition(index))
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
                                                            _createTextVNode(" Delete ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_78, [
                                                    _createVNode(_component_SelectInput, {
                                                      modelValue: condition.type,
                                                      "onUpdate:modelValue": [$event => ((condition.type) = $event), val => onConditionTypeChange(condition, val)],
                                                      name: "Condition Type",
                                                      options: [
                                      { name: 'Match Text', value: 'TextWorkflowCondition' },
                                      { name: 'Match Time', value: 'TimeWorkflowCondition' }
                                    ],
                                                      onInput: _cache[42] || (_cache[42] = $event => (hasUnsavedChanges.value = true))
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                    _createVNode(_component_SelectInput, {
                                                      modelValue: condition.operator,
                                                      "onUpdate:modelValue": $event => ((condition.operator) = $event),
                                                      name: "Condition Operator",
                                                      options: conditionOperatorOptions(condition.type),
                                                      onInput: _cache[43] || (_cache[43] = $event => (hasUnsavedChanges.value = true))
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
                                                    (condition.type === 'TimeWorkflowCondition')
                                                      ? (_openBlock(), _createBlock(_component_SelectInput, {
                                                          key: 0,
                                                          modelValue: condition.value,
                                                          "onUpdate:modelValue": $event => ((condition.value) = $event),
                                                          name: "Condition Value",
                                                          options: [{ name: 'Office Hours', value: 'working_hours' }],
                                                          onInput: _cache[44] || (_cache[44] = $event => (hasUnsavedChanges.value = true))
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                      : (_openBlock(), _createBlock(_component_InputField, {
                                                          key: 1,
                                                          modelValue: condition.value,
                                                          "onUpdate:modelValue": $event => ((condition.value) = $event),
                                                          name: "Condition Value",
                                                          placeholder: "Enter condition value",
                                                          onInput: _cache[45] || (_cache[45] = $event => (hasUnsavedChanges.value = true))
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                  ])
                                                ]))
                                              }), 128)),
                                              _createVNode(_component_NeueButton, {
                                                type: "secondary",
                                                onClick: addCondition
                                              }, {
                                                default: _withCtx(() => [...(_cache[67] || (_cache[67] = [
                                                  _createTextVNode("Add Condition", -1)
                                                ]))]),
                                                _: 1
                                              })
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'actions')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                            _createElementVNode("div", _hoisted_80, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (action, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  key: index,
                                                  class: "border rounded-lg p-4"
                                                }, [
                                                  _createElementVNode("div", _hoisted_81, [
                                                    _createElementVNode("h4", _hoisted_82, "Action " + _toDisplayString(index + 1), 1),
                                                    (actions.value.length > 1 && canUpdateAutomations.value)
                                                      ? (_openBlock(), _createBlock(_component_NeueButton, {
                                                          key: 0,
                                                          type: "red",
                                                          onClick: $event => (deleteAction(index))
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                                                            _createTextVNode(" Delete ", -1)
                                                          ]))]),
                                                          _: 1
                                                        }, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_83, [
                                                    _createVNode(_component_SelectInput, {
                                                      modelValue: action.type,
                                                      "onUpdate:modelValue": $event => ((action.type) = $event),
                                                      name: "Action Type",
                                                      options: _unref(workflowActionOptions)(),
                                                      onInput: _cache[46] || (_cache[46] = $event => (hasUnsavedChanges.value = true))
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
                                                    (
                                      action.type === 'SendSmsWorkflowAction' ||
                                      action.type === 'SkipDropWorkflowAction'
                                    )
                                                      ? (_openBlock(), _createBlock(_component_InputArea, {
                                                          key: 0,
                                                          modelValue: action.config.message,
                                                          "onUpdate:modelValue": $event => ((action.config.message) = $event),
                                                          name: 
                                      action.type === 'SkipDropWorkflowAction'
                                        ? 'Reply Message (optional)'
                                        : 'Action Message'
                                    ,
                                                          placeholder: 
                                      action.type === 'SkipDropWorkflowAction'
                                        ? 'Optional message to send back to the customer'
                                        : 'Enter message to send'
                                    ,
                                                          onInput: _cache[47] || (_cache[47] = $event => (hasUnsavedChanges.value = true))
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "placeholder"]))
                                                      : (action.type === 'AssignTagWorkflowAction')
                                                        ? (_openBlock(), _createBlock(_component_InputField, {
                                                            key: 1,
                                                            modelValue: action.config.tag_text,
                                                            "onUpdate:modelValue": $event => ((action.config.tag_text) = $event),
                                                            name: "Tag Name",
                                                            placeholder: "e.g. VIP",
                                                            onInput: _cache[48] || (_cache[48] = $event => (hasUnsavedChanges.value = true))
                                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                        : (action.type === 'GiveAccountCreditWorkflowAction')
                                                          ? (_openBlock(), _createBlock(_component_InputField, {
                                                              key: 2,
                                                              modelValue: action.config.amount,
                                                              "onUpdate:modelValue": $event => ((action.config.amount) = $event),
                                                              name: "Credit Amount",
                                                              placeholder: "e.g. 25.00",
                                                              prefix: "$",
                                                              restrict: "monetary",
                                                              onInput: _cache[49] || (_cache[49] = $event => (hasUnsavedChanges.value = true))
                                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                          : (action.type === 'AssignMembershipTierWorkflowAction')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                _createVNode(_component_SelectInput, {
                                                                  modelValue: action.config.membership_tier_id,
                                                                  "onUpdate:modelValue": $event => ((action.config.membership_tier_id) = $event),
                                                                  name: "Membership Tier",
                                                                  placeholder: "Select a membership tier",
                                                                  options: tierOptions.value,
                                                                  onInput: _cache[50] || (_cache[50] = $event => (hasUnsavedChanges.value = true))
                                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]),
                                                                (tierOption(action.config.membership_tier_id)?.hasMealPlan)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_84, " This tier has a meal plan. Customers moved onto it by this workflow are charged their first meal plan payment right away. "))
                                                                  : _createCommentVNode("", true)
                                                              ], 64))
                                                            : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              }), 128)),
                                              _createVNode(_component_NeueButton, {
                                                type: "secondary",
                                                onClick: addAction
                                              }, {
                                                default: _withCtx(() => [...(_cache[69] || (_cache[69] = [
                                                  _createTextVNode("Add Action", -1)
                                                ]))]),
                                                _: 1
                                              })
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'preview')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                            (type.value !== 'workflow')
                                              ? (_openBlock(), _createBlock(_component_InputField, {
                                                  key: 0,
                                                  modelValue: name.value,
                                                  "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => ((name).value = $event)),
                                                  name: "Automation name",
                                                  placeholder: "(Optional)",
                                                  disabled: !canUpdateAutomations.value,
                                                  onInput: _cache[52] || (_cache[52] = $event => (hasUnsavedChanges.value = true))
                                                }, null, 8, ["modelValue", "disabled"]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("dl", _hoisted_86, [
                                              _createElementVNode("div", _hoisted_87, [
                                                _cache[70] || (_cache[70] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Type", -1)),
                                                _createElementVNode("dd", _hoisted_88, _toDisplayString(type.value === 'drop' ? 'Drop' : type.value === 'workflow' ? 'Workflow' : 'Message'), 1)
                                              ]),
                                              (type.value !== 'workflow')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                                                    _cache[71] || (_cache[71] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Lists", -1)),
                                                    (type.value === 'message')
                                                      ? (_openBlock(), _createElementBlock("dd", _hoisted_90, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recipientRows.value, (row) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              key: row.id,
                                                              class: "flex justify-between gap-4"
                                                            }, [
                                                              _createElementVNode("span", null, _toDisplayString(row.name), 1),
                                                              (row.count)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(row.count), 1))
                                                                : _createCommentVNode("", true)
                                                            ]))
                                                          }), 128)),
                                                          (recipientSummaryText.value)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_92, _toDisplayString(recipientSummaryText.value), 1))
                                                            : _createCommentVNode("", true)
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("dd", _hoisted_93, _toDisplayString(selectedAudiences.value.map(x => x.attributes.audience_name).join(', ')), 1))
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (type.value === 'message')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _createElementVNode("div", _hoisted_94, [
                                                      _cache[72] || (_cache[72] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Message", -1)),
                                                      _createElementVNode("dd", _hoisted_95, _toDisplayString(message.value), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_96, [
                                                      _cache[73] || (_cache[73] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Send time", -1)),
                                                      _createElementVNode("dd", _hoisted_97, _toDisplayString(now.value
                                        ? 'Now'
                                        : new Intl.DateTimeFormat([], {
                                            dateStyle: 'medium',
                                            timeStyle: 'short'
                                          }).format(date.value) +
                                          (repeat.value === 'once' ? '' : ', repeat ' + repeat.value.replace('-', ' '))), 1)
                                                    ])
                                                  ], 64))
                                                : (type.value === 'workflow')
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                      _createElementVNode("div", _hoisted_98, [
                                                        _cache[74] || (_cache[74] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Workflow Name", -1)),
                                                        _createElementVNode("dd", _hoisted_99, _toDisplayString(workflowName.value), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_100, [
                                                        _cache[75] || (_cache[75] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Trigger", -1)),
                                                        _createElementVNode("dd", _hoisted_101, _toDisplayString(triggerType.value === 'ReceivedSmsWorkflowTrigger' ? 'Receive SMS' : triggerType.value), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_102, [
                                                        _cache[76] || (_cache[76] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Conditions", -1)),
                                                        _createElementVNode("dd", _hoisted_103, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conditions.value, (condition, index) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              key: index,
                                                              class: "mb-2"
                                                            }, _toDisplayString(condition.type === 'TextWorkflowCondition' ? 'Match Text' : condition.type) + ": " + _toDisplayString(condition.operator.replace('_', ' ')) + " \"" + _toDisplayString(condition.value) + "\" ", 1))
                                                          }), 128))
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_104, [
                                                        _cache[78] || (_cache[78] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Actions", -1)),
                                                        _createElementVNode("dd", _hoisted_105, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (action, index) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              key: index,
                                                              class: "mb-2"
                                                            }, [
                                                              (action.type === 'SendSmsWorkflowAction')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createTextVNode(" Send SMS: \"" + _toDisplayString(action.config.message) + "\" ", 1)
                                                                  ], 64))
                                                                : (action.type === 'SkipDropWorkflowAction')
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                      _cache[77] || (_cache[77] = _createTextVNode(" Skip Drop ", -1)),
                                                                      (action.config.message)
                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                            _createTextVNode(" : \"" + _toDisplayString(action.config.message) + "\" ", 1)
                                                                          ], 64))
                                                                        : _createCommentVNode("", true)
                                                                    ], 64))
                                                                  : (action.type === 'AssignTagWorkflowAction')
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                        _createTextVNode(" Assign tag: \"" + _toDisplayString(action.config.tag_text) + "\" ", 1)
                                                                      ], 64))
                                                                    : (action.type === 'GiveAccountCreditWorkflowAction')
                                                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                          _createTextVNode(" Give account credit: $" + _toDisplayString(action.config.amount), 1)
                                                                        ], 64))
                                                                      : (action.type === 'AssignMembershipTierWorkflowAction')
                                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                                            _createTextVNode(" Assign membership tier: " + _toDisplayString(tierOption(action.config.membership_tier_id)?.name ??
                                          'tier no longer available'), 1)
                                                                          ], 64))
                                                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                                            _createTextVNode(_toDisplayString(action.type), 1)
                                                                          ], 64))
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ])
                                                    ], 64))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                      _createElementVNode("div", _hoisted_106, [
                                                        _cache[79] || (_cache[79] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Store", -1)),
                                                        _createElementVNode("dd", _hoisted_107, _toDisplayString(_unref(mapRelationship)({ type: 'store', id: store.value })?.attributes.store_name), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_108, [
                                                        _cache[80] || (_cache[80] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Fulfillment", -1)),
                                                        _createElementVNode("dd", _hoisted_109, _toDisplayString(days.value.length === 1 ? '1 day selected' : days.value.length + ' days selected'), 1)
                                                      ]),
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reminders.value, (reminder, i) => {
                                                        return (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                                          _createElementVNode("dt", _hoisted_111, "Reminder " + _toDisplayString(i + 1), 1),
                                                          _createElementVNode("dd", _hoisted_112, _toDisplayString(new Intl.DateTimeFormat([], { dateStyle: 'medium', timeStyle: 'short' }).format(
                                        reminder.date
                                      ) +
                                      ', ' +
                                      reminder.message), 1)
                                                        ]))
                                                      }), 256)),
                                                      _createElementVNode("div", _hoisted_113, [
                                                        _cache[81] || (_cache[81] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Autofill", -1)),
                                                        _createElementVNode("dd", _hoisted_114, _toDisplayString(autofill.enabled
                                        ? {
                                            RefillAutofill: 'Refill the cart from the last order',
                                            CategoryAutofill: 'Match the number of items in each category'
                                          }[autofill.type]
                                        : 'Disabled'), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_115, [
                                                        _cache[82] || (_cache[82] = _createElementVNode("dt", { class: "text-sm font-medium leading-6 text-gray-900" }, "Autocharge", -1)),
                                                        _createElementVNode("dd", _hoisted_116, _toDisplayString(autocharge.enabled
                                        ? new Intl.DateTimeFormat([], {
                                            dateStyle: 'medium',
                                            timeStyle: 'short'
                                          }).format(autocharge.date)
                                        : 'Disabled'), 1)
                                                      ])
                                                    ], 64))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_117, [
                                      (currentStep.value > 0 && existing.value)
                                        ? (_openBlock(), _createBlock(_component_NeueButton, {
                                            key: 0,
                                            type: "secondary",
                                            disabled: !canUpdateAutomations.value,
                                            class: _normalizeClass(!canUpdateAutomations.value && 'opacity-50 cursor-not-allowed'),
                                            onClick: _cache[53] || (_cache[53] = $event => (currentStep.value--))
                                          }, {
                                            default: _withCtx(() => [...(_cache[83] || (_cache[83] = [
                                              _createTextVNode(" Previous ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["disabled", "class"]))
                                        : _createCommentVNode("", true),
                                      (step.id !== 'preview')
                                        ? (_openBlock(), _createBlock(_component_NeueButton, {
                                            key: 1,
                                            type: stepValid.value && canUpdateAutomations.value ? 'primary' : 'inactive',
                                            disabled: !canUpdateAutomations.value,
                                            onClick: _cache[54] || (_cache[54] = $event => (currentStep.value++))
                                          }, {
                                            default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                                              _createTextVNode(" Next ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["type", "disabled"]))
                                        : _createCommentVNode("", true),
                                      (
                              step.id === 'message-reminders' &&
                              reminders.value.indexOf(step.reminder) === reminders.value.length - 1 &&
                              canUpdateAutomations.value
                            )
                                        ? (_openBlock(), _createBlock(_component_NeueButton, {
                                            key: 2,
                                            type: "secondary",
                                            onClick: addReminder
                                          }, {
                                            default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                                              _createTextVNode(" Add reminder ", -1)
                                            ]))]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (step.id === 'message-reminders' && reminders.value.length > 1 && canUpdateAutomations.value)
                                        ? (_openBlock(), _createBlock(_component_NeueButton, {
                                            key: 3,
                                            type: "red",
                                            onClick: $event => (deleteReminder(step.reminder))
                                          }, {
                                            default: _withCtx(() => [...(_cache[86] || (_cache[86] = [
                                              _createTextVNode(" Delete reminder ", -1)
                                            ]))]),
                                            _: 1
                                          }, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      (step.id === 'preview' && !existing.value && canCreateAutomations.value)
                                        ? (_openBlock(), _createBlock(_component_NeueButton, {
                                            key: 4,
                                            type: "primary",
                                            onClick: submitCreate
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" Confirm and " + _toDisplayString(type.value === 'message' && now.value ? 'send' : 'schedule'), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (i !== steps.value.length - 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_118))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["group relative flex items-center", (existing.value || (i === currentStep.value + 1 && stepValid.value)) && 'cursor-pointer']),
                                  onClick: 
                        () => {
                          if (existing.value || (i === currentStep.value + 1 && stepValid.value)) {
                            currentStep.value = i
                          }
                        }
                      
                                }, [
                                  _createElementVNode("span", _hoisted_120, [
                                    _createElementVNode("span", _hoisted_121, [
                                      (step.id === 'lists')
                                        ? (_openBlock(), _createBlock(_unref(RectangleGroupIcon), {
                                            key: 0,
                                            class: "h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                          }))
                                        : _createCommentVNode("", true),
                                      (step.id === 'message' || step.id === 'message-reminders')
                                        ? (_openBlock(), _createBlock(_unref(ChatBubbleOvalLeftEllipsisIcon), {
                                            key: 1,
                                            class: "h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                          }))
                                        : _createCommentVNode("", true),
                                      (step.id === 'store')
                                        ? (_openBlock(), _createBlock(_unref(ShoppingBagIcon), {
                                            key: 2,
                                            class: "h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                          }))
                                        : _createCommentVNode("", true),
                                      (step.id === 'fulfillment')
                                        ? (_openBlock(), _createBlock(_unref(CalendarIcon), {
                                            key: 3,
                                            class: "h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                          }))
                                        : _createCommentVNode("", true),
                                      (step.id === 'time')
                                        ? (_openBlock(), _createBlock(_unref(ClockIcon), {
                                            key: 4,
                                            class: "h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                          }))
                                        : _createCommentVNode("", true),
                                      (step.id === 'autofill')
                                        ? (_openBlock(), _createBlock(_unref(Cog6ToothIcon), {
                                            key: 5,
                                            class: "h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                          }))
                                        : _createCommentVNode("", true),
                                      (step.id === 'autocharge')
                                        ? (_openBlock(), _createBlock(_unref(CreditCardIcon), {
                                            key: 6,
                                            class: "h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                          }))
                                        : _createCommentVNode("", true),
                                      (step.id === 'preview')
                                        ? (_openBlock(), _createBlock(_unref(DocumentCheckIcon), {
                                            key: 7,
                                            class: "h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                          }))
                                        : _createCommentVNode("", true),
                                      (
                              step.id === 'workflow-name' ||
                              step.id === 'trigger' ||
                              step.id === 'conditions' ||
                              step.id === 'actions'
                            )
                                        ? (_openBlock(), _createBlock(_unref(Cog6ToothIcon), {
                                            key: 8,
                                            class: "h-5 w-5 text-gray-400 group-hover:text-gray-500"
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("span", _hoisted_122, [
                                    _createElementVNode("span", _hoisted_123, [
                                      _createElementVNode("span", _hoisted_124, _toDisplayString(step.name), 1),
                                      (step.reminder?.completed)
                                        ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                            key: 0,
                                            class: "h-5 w-5",
                                            "aria-hidden": "true"
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (existing.value)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_125, _toDisplayString(stepPreview(step)), 1))
                                      : _createCommentVNode("", true)
                                  ])
                                ], 10, _hoisted_119)
                              ], 64))
                      ], 2))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          (existing.value)
            ? (_openBlock(), _createBlock(_component_PageFooter, { key: 0 }, {
                left: _withCtx(() => [
                  (canDeleteAutomations.value)
                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                        key: 0,
                        type: "red",
                        onClick: deleteAutomation
                      }, {
                        default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                          _createTextVNode("Delete", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                right: _withCtx(() => [
                  (hasUnsavedChanges.value && canUpdateAutomations.value)
                    ? (_openBlock(), _createBlock(_component_NeueButton, {
                        key: 0,
                        type: "primary",
                        onClick: submitSave
                      }, {
                        default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                          _createTextVNode(" Save ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_AutoChargeConfirmModal, {
      "is-open": autoChargeConfirmOpen.value,
      audiences: autoChargeConfirmAudiences.value,
      onConfirm: confirmAutocharge,
      onCancel: cancelAutocharge
    }, null, 8, ["is-open", "audiences"])
  ], 64))
}
}

}